
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { isAlreadyPending } from '@/store/root'

import { RButton, RInput } from '@/components/'

import { removeSpaces } from '@/services/strings'

export default Vue.extend({
  name: 'Invite',
  components: {
    RButton,
    RInput,
  },
  data() {
    return {
      emails: '',
    }
  },
  methods: {
    ...mapActions({
      inviteTeamMembers: 'team/inviteTeamMembers',
    }),
    sendInvite() {
      let rawEmailsArray = this.emails.split(',')
      const emailsToInvite = rawEmailsArray.map((email: string) => removeSpaces(email)) // shouldn't it be additionally sanitized?

      this.inviteTeamMembers(emailsToInvite)
    },
  },
  computed: {
    ...mapGetters({
      sendInviteRequest: 'team/sendInviteRequest',
    }),

    sendInviteRequestPending(): boolean {
      return isAlreadyPending(this.sendInviteRequest)
    },
  },
})
